import { render, staticRenderFns } from "./trouble-install.vue?vue&type=template&id=283688a6"
import script from "./trouble-install.vue?vue&type=script&lang=js"
export * from "./trouble-install.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports